import * as React from 'react'
import { AlertTriangleIcon } from 'lucide-react'
import { cn } from '@/lib/utils'

interface ErrorMessageProps extends React.HTMLAttributes<HTMLDivElement> {
  message?: string
  children?: React.ReactNode
  icon?: boolean
}

export const ErrorMessage = React.forwardRef<HTMLDivElement, ErrorMessageProps>(
  ({ className, message, children, icon = true, ...props }, ref) => {
    const content = message || children

    if (!content) return null

    return (
      <div
        ref={ref}
        className={cn(
          'flex items-start gap-2 rounded-md text-sm text-destructive',
          className
        )}
        {...props}
      >
        {icon && <AlertTriangleIcon className="h-4 w-4 mt-0.5 flex-shrink-0" />}
        <span>{content}</span>
      </div>
    )
  }
)

ErrorMessage.displayName = 'ErrorMessage'
